import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { catchError, Observable, switchMap, throwError } from "rxjs";
import { Injectable } from "@angular/core";
import { AuthenticationService } from "../authentication/authentication/authentication.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  isRefreshing = false;

  constructor(private authService: AuthenticationService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next
      .handle(
        req.clone({
          setHeaders: {
            Authorization: this.authService.getAuthorizationHeaderValue(),
          },
        })
      )
      .pipe(
        catchError((error: HttpErrorResponse) => {
          if (error && error.status === 401) {
            return this.handle401Error(req, next);
          }
        })
      );
  }

  // if the session expires after prolonged inactivity and the auto-token refresh fails,
  // app should manually refresh token in case of 401 errors
  handle401Error(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      return this.authService.manuallyRefreshToken().pipe(
        switchMap((refresh) => {
          this.isRefreshing = false;
          if (refresh.type === "silently_refreshed") {
            return next.handle(
              req.clone({
                setHeaders: {
                  Authorization: this.authService.getAuthorizationHeaderValue(),
                },
              })
            );
          } else {
            this.isRefreshing = false;
            this.authService.logOut();
            return throwError(() => refresh);
          }
        }),
        catchError((err) => {
          this.isRefreshing = false;
          this.authService.logOut();
          return throwError(() => err);
        })
      );
    }
  }
}
